module.exports = __webpack_public_path__ + "97d88fa39407db76595ca13e2d8628e8.png";